import { useMemo, type FunctionComponent } from 'react';
import { useWatch } from '@kanda-libs/ks-component-ts';

import Employed from './Employed';
import SelfEmployed from './SelfEmployed';
import NotEmployed from './NotEmployed';
import Retired from './Retired';

import { EMPLOYMENT_STATUS_FIELD_NAME } from './constants';

export interface EmploymentInformationHook {
  Fields: FunctionComponent | null;
}

export default function useEmploymentInformation(): EmploymentInformationHook {
  const employmentStatus = useWatch({
    name: EMPLOYMENT_STATUS_FIELD_NAME,
  });

  const fields = useMemo(() => {
    if (employmentStatus === 'employed') return Employed;
    if (employmentStatus === 'self_employed') return SelfEmployed;
    if (employmentStatus === 'not_employed') return NotEmployed;
    if (employmentStatus === 'retired') return Retired;
    return null;
  }, [employmentStatus]);

  return {
    Fields: fields as FunctionComponent,
  };
}
